/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentDuplicatedStatusFault } from "./PaymentDuplicatedStatusFault";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum FaultCodeCategoryEnum {
  "PAYMENT_DUPLICATED" = "PAYMENT_DUPLICATED"
}

/**
 * A PaymentProblemJson-like type specific for the GetPayment and ActivatePayment operations.
 * Possible values of `detail_v2` are limited to faults pertaining to Nodo errors related to payment status conflicts.
 */

// required attributes
const PaymentDuplicatedStatusFaultPaymentProblemJsonR = t.interface({
  faultCodeCategory: enumType<FaultCodeCategoryEnum>(
    FaultCodeCategoryEnum,
    "faultCodeCategory"
  ),

  faultCodeDetail: PaymentDuplicatedStatusFault
});

// optional attributes
const PaymentDuplicatedStatusFaultPaymentProblemJsonO = t.partial({
  title: t.string
});

export const PaymentDuplicatedStatusFaultPaymentProblemJson = t.intersection(
  [
    PaymentDuplicatedStatusFaultPaymentProblemJsonR,
    PaymentDuplicatedStatusFaultPaymentProblemJsonO
  ],
  "PaymentDuplicatedStatusFaultPaymentProblemJson"
);

export type PaymentDuplicatedStatusFaultPaymentProblemJson = t.TypeOf<
  typeof PaymentDuplicatedStatusFaultPaymentProblemJson
>;
